const ModelRoot = () => 'Click on a root class to explore the equipment data model';

export default ModelRoot;
